import { Button } from '@src/design-system/button';
import {
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from '@src/design-system/dialog';
import { useEditResetPassword } from '@features/users/pages/detail/services/reset-password';
import { RefreshRightSquare } from 'iconsax-react';
import { useRef } from 'react';

const ResetPasswordModal = ({ email }: { email: string }) => {
  const closeRef = useRef<HTMLButtonElement>(null);
  const { mutateAsync, isPending } = useEditResetPassword();

  const handleResetPassword = async () => {
    await mutateAsync({ email });
    closeRef.current?.click();
  };

  return (
    <DialogContent align='center'>
      <DialogHeader className='bg-white' />
      <DialogBody className='flex justify-center items-center flex-col'>
        <span className='flex justify-center items-center rounded-2xl bg-primary-100 p-2 mb-4'>
          <RefreshRightSquare
            className='text-primary-1000'
            variant='TwoTone'
            size={35}
          />
        </span>
        <p className='text-center text-gray-700 whitespace-pre-line'>
          Are you Sure to reset the password for this user?
        </p>
      </DialogBody>
      <DialogFooter className='sm:justify-center pt-0'>
        <DialogClose ref={closeRef}>
          <Button
            variant='primaryOutline'
            className='text-gray-800 border-primary-200'
          >
            Cancel
          </Button>
        </DialogClose>
        <Button
          isLoading={isPending}
          disabled={isPending}
          variant='primary'
          onClick={handleResetPassword}
        >
          Confirm
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default ResetPasswordModal;
